module.exports = __webpack_public_path__ + "static/media/lt-surge-1.68063912.wav";